module.exports = __webpack_public_path__ + "media/images/bank_images/banestes-8097d899ca42459d426aaa369022e472.png";